import { GET_EVENTS_SUCCESS, UPDATE_LINES_SUCCESS } from 'constants/actionTypes'

import { union, isNil, get, endsWith, uniq } from 'lodash'

import channelsConfig from 'websocket/channelsConfig'

const MAX_FOR_UPDATE = 350
const MERGE_CHANNELS = true
const DASH = '-'

const filterInvalidValue = (value) => value && !endsWith(value, DASH)

function _createComposedKey(array) {
  return array.join('-')
}

function _createComposedValue(element, keys, staticKeyValues = {}) {
  const values = keys.map((key) =>
    isNil(staticKeyValues[key]) ? element[key] : staticKeyValues[key],
  )

  return values.join('-')
}

function _haveTheConditions(element, conditions) {
  if (!conditions) return true

  const passedtheConditions = conditions.every(
    ({ key, value }) => element[key] === value,
  )

  return passedtheConditions
}

function _createChannel({ response, path, keys, staticKeyValues, conditions }) {
  const [firstPath] = path

  if (!response) return []

  const firstLevelElement = response[firstPath]
  const hasMoreThanOneLevel = path.length > 1

  if (!hasMoreThanOneLevel) {
    if (!firstLevelElement) return []

    return firstLevelElement.reduce((channels, element) => {
      if (!_haveTheConditions(element, conditions)) return channels

      const composedValue = _createComposedValue(element, keys, staticKeyValues)

      if (channels.includes(composedValue)) return channels

      return channels.concat(composedValue)
    }, [])
  }

  // eslint-disable-next-line no-use-before-define
  return _createChannelAtDeepLevel(
    firstLevelElement,
    path.slice(1),
    keys,
    conditions,
  )
}

function _createChannelAtDeepLevel(elements, path, keys) {
  return (
    elements &&
    elements.reduce(
      (channels, element) =>
        union(channels, _createChannel({ response: element, path, keys })),
      [],
    )
  )
}

function _mergeChannels(state, newChannels) {
  const newState = { ...newChannels }

  Object.keys(newState).forEach((key) => {
    if (state[key]) {
      newState[key] = [...state[key], ...newState[key]].reduce((acc, room) => {
        if (!acc.includes(room)) {
          acc.push(room)
        }

        return acc
      }, [])
    }
  })

  return newState
}

function setChannels(state, response, pushData) {
  const newState = channelsConfig.reduce(
    (newChannels, { keys, path, staticKeyValues, conditions }) => {
      const key = _createComposedKey(keys)
      const values = _createChannel({
        response,
        path,
        keys,
        staticKeyValues,
        conditions,
      }).filter(filterInvalidValue)

      newChannels[key] = newChannels[key]
        ? uniq(newChannels[key].concat(values))
        : values

      return newChannels
    },
    {},
  )
  const shouldMerge = pushData && state.eid && state.eid.length < MAX_FOR_UPDATE

  if (shouldMerge) return _mergeChannels(state, newState)

  return newState
}

function _addOneLineIfNotHaveLines(res) {
  const response = { ...res }

  response.events =
    res.events &&
    res.events.map((event) => {
      const newEvent = { ...event }

      if (get(newEvent, 'currentLines', []).length === 0) {
        newEvent.currentLines = [
          { eid: get(event, 'eid'), mtid: get(event, 'marketType.mtid') },
        ]
      }

      return newEvent
    })

  return response
}

const initialState = {}

const handlers = {
  [GET_EVENTS_SUCCESS]: (state, payload) =>
    setChannels(state, _addOneLineIfNotHaveLines(payload), !MERGE_CHANNELS),
  [UPDATE_LINES_SUCCESS]: (state, { currentLines }) =>
    setChannels(
      state,
      _addOneLineIfNotHaveLines({ events: [{ currentLines }] }),
      MERGE_CHANNELS,
    ),
}

export default function channelsReduce(
  state = initialState,
  { type, payload },
) {
  return handlers[type] ? handlers[type](state, payload) : state
}
